// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AddItemsFromExistingPlanModalQueryVariables = Types.Exact<{
  filter: Types.PlanPackageFilter;
}>;


export type AddItemsFromExistingPlanModalQuery = { __typename?: 'Query', planPackages: { __typename?: 'PlanPackagesPageResult', entities: Array<{ __typename?: 'PlanPackage', id: string, displayName: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } }> } };


export const AddItemsFromExistingPlanModalDocument = gql`
    query AddItemsFromExistingPlanModal($filter: PlanPackageFilter!) {
  planPackages(filter: $filter) {
    entities {
      id
      displayName
      status: effectiveStatus {
        code
        name
      }
      aggregateLatest {
        id
        displayVersion
      }
    }
  }
}
    `;

/**
 * __useAddItemsFromExistingPlanModalQuery__
 *
 * To run a query within a React component, call `useAddItemsFromExistingPlanModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddItemsFromExistingPlanModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddItemsFromExistingPlanModalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAddItemsFromExistingPlanModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddItemsFromExistingPlanModalQuery, AddItemsFromExistingPlanModalQueryVariables> & ({ variables: AddItemsFromExistingPlanModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddItemsFromExistingPlanModalQuery, AddItemsFromExistingPlanModalQueryVariables>(AddItemsFromExistingPlanModalDocument, options);
      }
export function useAddItemsFromExistingPlanModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddItemsFromExistingPlanModalQuery, AddItemsFromExistingPlanModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddItemsFromExistingPlanModalQuery, AddItemsFromExistingPlanModalQueryVariables>(AddItemsFromExistingPlanModalDocument, options);
        }
// @ts-ignore
export function useAddItemsFromExistingPlanModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddItemsFromExistingPlanModalQuery, AddItemsFromExistingPlanModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddItemsFromExistingPlanModalQuery, AddItemsFromExistingPlanModalQueryVariables>;
export function useAddItemsFromExistingPlanModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddItemsFromExistingPlanModalQuery, AddItemsFromExistingPlanModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddItemsFromExistingPlanModalQuery | undefined, AddItemsFromExistingPlanModalQueryVariables>;
export function useAddItemsFromExistingPlanModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddItemsFromExistingPlanModalQuery, AddItemsFromExistingPlanModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddItemsFromExistingPlanModalQuery, AddItemsFromExistingPlanModalQueryVariables>(AddItemsFromExistingPlanModalDocument, options);
        }
export type AddItemsFromExistingPlanModalQueryHookResult = ReturnType<typeof useAddItemsFromExistingPlanModalQuery>;
export type AddItemsFromExistingPlanModalLazyQueryHookResult = ReturnType<typeof useAddItemsFromExistingPlanModalLazyQuery>;
export type AddItemsFromExistingPlanModalSuspenseQueryHookResult = ReturnType<typeof useAddItemsFromExistingPlanModalSuspenseQuery>;
export type AddItemsFromExistingPlanModalQueryResult = ApolloReactCommon.QueryResult<AddItemsFromExistingPlanModalQuery, AddItemsFromExistingPlanModalQueryVariables>;